// @flow
import tinycolor from 'tinycolor2'

// Types
export type Props = {
  $size: string,
  $color: string,
  $loading: boolean,
  $fullWidth: boolean,
  $palette: Function,
}

// Constants
export const SIZES = {
  inherit: '1em',
  normal: '0.87rem',
  medium: '1.2rem',
  small: '.78rem',
  large: '1.7em',
}

export const BasicButton = ({ $size, $fullWidth }: Props) => ({
  fontSize: SIZES[$size] || SIZES.normal,
  borderRadius: '.25rem',
  width: $fullWidth ? '100%' : 'initial',
  backgroundImage: 'none',
  padding: '.62em .94em',
  flexFlow: 'row nowrap',
  justifyContent: 'stretch',
  alignItems: 'center',
  userSelect: 'none',
  fontWeight: 400,
  display: 'flex',
  cursor: 'pointer',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  border: '1px solid transparent',
  appearance: 'none',
  textDecoration: 'none',
})

export const StyledButton = (props: Props) => {
  const { $color, $loading, $palette } = props
  const bgColor = $palette($color).darken(3.1)
  const loadingMod = !$loading
    ? {}
    : {
        pointerEvents: 'none',
        opacity: 0.6,
      }
  const textColor = tinycolor.mostReadable(bgColor.clone().darken(17), [
    $palette('white'),
    $palette('text'),
  ])

  return {
    ...BasicButton(props),
    ...loadingMod,
    backgroundColor: `${bgColor}`,
    color: `${textColor}`,
    ':focus': {
      outline: 0,
      boxShadow: `0 0 0 .15rem ${bgColor.clone().lighten(15)}`,
    },
    ':hover': {
      backgroundColor: `${bgColor.clone().darken(5)}`,
    },
    ':active': {
      backgroundColor: `${bgColor.clone().darken(10)}`,
    },
    ':disabled': {
      opacity: 0.6,
      backgroundColor: `${bgColor}`,
    },
  }
}

export const ButtonText = {
  flexGrow: '1',
  flexShrink: '1',
  flexBasis: 'auto',
  whiteSpace: 'nowrap',
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  justifyContent: 'center',
}

export const LoadingContainer = {
  display: 'inline-flex',
  marginLeft: '10px',
}
